import React, {useContext} from 'react'
import Colors from 'app/react/components/colors/Colors'
import HeaderWithSelect from 'app/react/components/HeaderWithSelect'
import ColorsContext from 'app/react/components/colors/ColorsContext'
import classNames from 'classnames'

export default function ColorsContent () {

  const { headerTitle, headerText, selectLabel, selectOptions, setSelectedOption, textBelow, showColorVariations } = useContext(ColorsContext)

  const handleOnSelectChange = (e) => {
    setSelectedOption(e.target.value)
  }

  return (
    <section id="colors" className={classNames('dm-colors', {
      'dm-colors--no-variations': !showColorVariations
    })}>
      <div className="dm-colors__inner dm-page-container">
        <HeaderWithSelect
          title={headerTitle}
          text={headerText}
          label={selectLabel}
          selectOptions={selectOptions}
          onSelectChange={handleOnSelectChange}
        />
        <Colors/>
        {textBelow && (
          <p className="dm-colors__text-below">{textBelow}</p>
        )}
      </div>
    </section>
  )
}